module.exports = __webpack_public_path__ + "static/img/bg_shop_info_auth.38a78c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_shop_info_auth.png
// module id = PSrB
// module chunks = 1